import { z } from 'zod'

const ProgramAcademicTermStatusSchema = z.number().transform((val) => {
  switch (val) {
    case 0:
      return 'Planned' as const
    case 1:
      return 'Active' as const
    case 2:
      return 'Completed' as const
    case 3:
      return 'Inactive' as const
    default:
      return 'Unknown' as const
  }
})

export type AcademicTermProgramStatus = z.output<
  typeof ProgramAcademicTermStatusSchema
>

// Schema for the nested academic_term object
const AcademicTermSchema = z.object({
  academic_term_type_id: z.number(),
})

// Schema for the main academic term program object
const AcademicTermProgramSchema = z.object({
  id: z.number(),
  name: z.string(),
  purse_name: z.string().nullish(),
  academic_term: AcademicTermSchema,
  status: ProgramAcademicTermStatusSchema.catch('Unknown'),
})

const AcademicTermProgramArraySchema = z.array(AcademicTermProgramSchema)

// Scholarship Award schemas
const ProgramAcademicTermSchema = z.object({
  name: z.string().nullable(),
})

const StudentSchema = z.object({
  first_name: z.string(),
  last_name: z.string(),
})

const ScholarshipAwardSchema = z.object({
  student_id: z.number(),
  program_purse_name: z.string(),
  sequence_number: z.number().nullable(),
  program_academic_term: ProgramAcademicTermSchema,
  total_awarded: z.number(),
  last_distribution: z.string().nullable(),
  student: StudentSchema,
})

const ScholarshipAwardsResponseSchema = z.object({
  data: z.array(ScholarshipAwardSchema),
  total: z.number(),
})

// Export types
export type AcademicTerm = z.infer<typeof AcademicTermSchema>
export type AcademicTermProgram = z.infer<typeof AcademicTermProgramSchema>
export type AcademicTermProgramArray = z.infer<
  typeof AcademicTermProgramArraySchema
>
export type ScholarshipAward = z.infer<typeof ScholarshipAwardSchema>
export type ScholarshipAwardsResponse = z.infer<
  typeof ScholarshipAwardsResponseSchema
>

// Export schemas
export {
  AcademicTermSchema,
  AcademicTermProgramSchema,
  AcademicTermProgramArraySchema,
  ProgramAcademicTermSchema,
  StudentSchema,
  ScholarshipAwardSchema,
  ScholarshipAwardsResponseSchema,
}
